const triggerEvent = (el, type) => {
    if ('createEvent' in document) {
         // modern browsers, IE9+
         var e = document.createEvent('HTMLEvents');
         e.initEvent(type, false, true);
         el.dispatchEvent(e);
     } else {
         // IE 8
         var e = document.createEventObject();
         e.eventType = type;
         el.fireEvent('on'+e.eventType, e);
     }
 }

const tabSelectors = document.querySelectorAll('[data-tabs]');
if (tabSelectors) {
    for (const [i, tabs] of [...tabSelectors].entries()) {
        tabs.setAttribute('data-tabs', i);
        new Tabby(`[data-tabs="${i}"]`);
    }
}

function toggleTabs(sel) {
    for ([i, tabs] of [...tabSelectors].entries()) {
        tabs = new Tabby(`[data-tabs="${i}"]`);
        document.querySelectorAll(sel).forEach(tab => tabs.toggle(tab));
    }
}

document.addEventListener('tabby', function (event) {
    var tab = event.target;
    var content = event.detail.content;
    // console.log(tab)
    // console.log(content)    
    // $(tab.href).siblings().find(".fit-tabbed-slider").slick("refresh");
    // $(tab.href).find(".fit-tabbed-slider").slick("refresh");
    // $(".fit-tabbed-slider").slick("refresh");
}, false);

$(".fitting-styles-middle-nav-link").on("click", function(){
    var parentHandle = $(this).attr("data-parent-handle")
    triggerEvent($(`#tabby-toggle_${parentHandle}`)[0], "click")
    var $nav = $(this).parents(".fitting-styles-middle-nav");
    if(!$(this).closest("ul").find(`[aria-selected="true"]`).length){
        triggerEvent($(this)[0], "click")
    }
    if($(this).closest("li.has-children").length){
        var $otherLinks = $(this).closest("li.has-children").siblings().find("ul a");
        $otherLinks.each(function(){
            var handle = $(this).attr("href")
            $(this).attr("aria-selected", "false")
            $(handle).attr("hidden", "hidden")
        })
        // $otherLinks.attr("aria-selected", "false");
        // $($otherLinks.href).attr("hidden", "hidden")
        // $($otherLinks.href).siblings().attr("hidden", "hidden")
    }
})